import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import moment from 'moment';
import axios from 'axios';
import { MultiSelect } from 'primereact/multiselect';
import CBMediaQuery from '../shared/CBMediaQuery';
import CBSearchInput from '../shared/CBSearchInput';
import CBDatePickerInput from '../shared/CBDatePickerInput';
import CBSelectFilters from '../shared/CBSelectFilters';
import CBLabelAndCheckbox from '../shared/CBLabelAndCheckbox';
import CBButtonGarageAction from '../shared/CBButtonGarageAction';
import VehicleListTh from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTh';
import VehicleListTd from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTd';
import { finnishDateFormat, getStyle, styleMerge } from '../../utils/utils';
import { API_URL } from '../../config';
import {
  fetchCSMaintenanceReservations as _fetchCSMaintenanceReservations,
} from '../../actions/chainActions';
import { fetchCareServices as _fetchCareServices } from '../../actions/careServiceActions';
import { selectWorkshopChain as _selectWorkshopChain } from '../../actions/workshopActions';
import CreateChainMessageModal from '../ChainView/components/CreateChainMessageModal';
import ChainMessageDetailModal from '../MessagesView/MessagesViewComponents/ChainMessageDetailModal';
import { companySwitchState, listStateKey, loadListState, saveListState } from '../../utils/listState';

const SELECTED_FIELDS_KEY = 'selectedCSMaintenanceReservationFields';
// One-time flag so the customer-approval column is shown by default for existing users
// (whose saved column set predates the feature) without permanently forcing it.
const CUSTOMER_APPROVAL_DEFAULT_KEY = 'csUpcomingCustomerApprovalColumnDefaulted';

class CSUpcomingMaintenancesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      ordering: 'start',
      filters: {},
      page: 1,
      selectedReservations: [],
      fields: [],
      selectedFields: [],
      approvalModalIsOpen: false,
      singleApprovalReservation: null,
      singleApprovalModalIsOpen: false,
      availabilityModalIsOpen: false,
      singleAvailabilityReservation: null,
      singleAvailabilityModalIsOpen: false,
      customerApprovalModalIsOpen: false,
      singleCustomerApprovalReservation: null,
      singleCustomerApprovalModalIsOpen: false,
      detailMessage: null,
      detailModalIsOpen: false,
    };
    this.tableScrollRef = React.createRef();
    this.topScrollRef = React.createRef();
    this._isSyncingScroll = false;
  }

  componentDidMount() {
    this.syncTopScrollWidth();
    if (typeof ResizeObserver !== 'undefined' && this.tableScrollRef.current) {
      this._resizeObserver = new ResizeObserver(this.syncTopScrollWidth);
      this._resizeObserver.observe(this.tableScrollRef.current);
    }
  }

  componentWillUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  syncTopScrollWidth = () => {
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      var inner = this.topScrollRef.current.firstChild;
      if (inner) {
        inner.style.width = this.tableScrollRef.current.scrollWidth + 'px';
      }
    }
  };

  handleTopScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      this.tableScrollRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  handleTableScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.topScrollRef.current && this.tableScrollRef.current) {
      this.topScrollRef.current.scrollLeft = this.tableScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  componentWillMount() {
    const { workshop } = this.props;
    const t = (key) => this.props.t(key, { ns: 'ChainHomeView' });

    const allFields = [
      { label: t('headingRegNr'), value: 'reg_nr' },
      { label: t('headingOrganization'), value: 'organization_name' },
      { label: t('headingStartTime'), value: 'start' },
      { label: t('headingEndTime'), value: 'end' },
      { label: t('headingDescription'), value: 'description' },
      { label: t('headingCreatedAt'), value: 'autofutur_created' },
      { label: t('headingBooker'), value: 'user_id' },
      { label: t('headingPartsOrdered'), value: 'part_items_ordered' },
      { label: t('headingLatestKm'), value: 'latest_km' },
      { label: t('headingLastMaintenance'), value: 'last_maintenance' },
      { label: t('headingApprovalStatus'), value: 'approval_status' },
      { label: t('headingNewApprovalRequest'), value: 'new_approval_request' },
      { label: t('headingNewAvailabilityInquiry'), value: 'new_availability_inquiry' },
      { label: t('headingNewCustomerApproval'), value: 'new_customer_approval' },
    ];

    const savedFields = localStorage.getItem(SELECTED_FIELDS_KEY);
    let selectedFields = savedFields
      ? JSON.parse(savedFields)
      : ['reg_nr', 'organization_name', 'start', 'description', 'new_customer_approval'];

    // One-time migration: surface the customer-approval column by default for existing
    // users who already had a saved column set. They can still hide it afterwards.
    if (!localStorage.getItem(CUSTOMER_APPROVAL_DEFAULT_KEY)) {
      if (savedFields && selectedFields.indexOf('new_customer_approval') === -1) {
        selectedFields = selectedFields.concat(['new_customer_approval']);
        localStorage.setItem(SELECTED_FIELDS_KEY, JSON.stringify(selectedFields));
      }
      localStorage.setItem(CUSTOMER_APPROVAL_DEFAULT_KEY, '1');
    }

    this.setState({
      fields: allFields,
      selectedFields,
    });

    if (workshop) {
      this.props.fetchCareServices({ workshop_id: workshop.id });
      const savedState = this.loadListStateFromStorage();
      this.setState(companySwitchState(savedState, this.state.ordering), () => {
        this.refetchReservations();
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.syncTopScrollWidth();
    const { workshop, selectedWorkshopChainId } = this.props;
    const prevWorkshop = prevProps.workshop;

    if (selectedWorkshopChainId !== prevProps.selectedWorkshopChainId && workshop) {
      this.setState({ page: 1 }, () => this.refetchReservations());
      return;
    }

    if (workshop && prevWorkshop && workshop.id !== prevWorkshop.id) {
      this.props.fetchCareServices({ workshop_id: workshop.id });
      // A workshop with no saved state of its own starts clean: keeping the
      // previous workshop's search and filters would both show the wrong list
      // and — since refetchReservations persists what it sent — write them into
      // the new workshop's entry (see utils/listState).
      const savedState = this.loadListStateFromStorage();
      this.setState(companySwitchState(savedState, this.state.ordering), () => {
        this.refetchReservations();
      });
    }
  }

  getCompanyScopeKey = () => {
    const { workshop } = this.props;
    return listStateKey('maintenanceReservationListState', 'workshop', workshop ? workshop.id : null);
  }

  saveListStateToStorage = () => {
    const { search, ordering, filters, page } = this.state;
    saveListState(this.getCompanyScopeKey(), { search, ordering, filters, page });
  }

  loadListStateFromStorage = () => loadListState(this.getCompanyScopeKey())

  refetchReservations = () => {
    const { fetchCSMaintenanceReservations, workshop, selectedWorkshopChainId } = this.props;
    const { search, ordering, filters } = this.state;

    if (!workshop) return;

    const params = {
      search,
      ordering,
      ...filters,
    };

    if (selectedWorkshopChainId) {
      params.chain_id = selectedWorkshopChainId;
    }

    fetchCSMaintenanceReservations(workshop.id, params);
    this.saveListStateToStorage();
  };

  changeSearchTerms = (value) => {
    this.setState({
      search: value,
    }, () => {
      this.saveListStateToStorage();
    });
  }

  changeFilterTerms = (newFilters) => {
    this.setState({
      filters: { ...this.state.filters, ...newFilters },
      page: 1,
    }, () => {
      this.saveListStateToStorage();
      this.refetchReservations();
    });
  }

  changeOrdering = (clickedOrdering) => {
    const { ordering } = this.state;
    let newOrdering;
    if (ordering === clickedOrdering) {
      newOrdering = `-${ordering}`;
    } else if (`-${ordering}` === clickedOrdering) {
      newOrdering = 'start';
    } else {
      newOrdering = clickedOrdering;
    }
    this.setState({
      ordering: newOrdering,
      page: 1,
    }, () => {
      this.saveListStateToStorage();
      this.refetchReservations();
    });
  };

  getOrderingSymbol = (columnName) => {
    const { ordering } = this.state;
    if (ordering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (ordering === `-${columnName}`) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  selectReservation = (reservationId) => {
    const { selectedReservations } = this.state;
    const newSelected = selectedReservations.slice();
    newSelected.push(reservationId);
    this.setState({ selectedReservations: newSelected });
  };

  unselectReservation = (reservationId) => {
    const { selectedReservations } = this.state;
    const newSelected = selectedReservations.filter((id) => id !== reservationId);
    this.setState({ selectedReservations: newSelected });
  };

  selectAllChanged = () => {
    const { csMaintenanceReservations } = this.props;
    const { selectedReservations } = this.state;
    const allChecked = csMaintenanceReservations && selectedReservations.length === csMaintenanceReservations.length;

    if (allChecked) {
      this.setState({ selectedReservations: [] });
    } else {
      const allIds = csMaintenanceReservations ? csMaintenanceReservations.map((r) => r.id) : [];
      this.setState({ selectedReservations: allIds });
    }
  };

  openApprovalRequestModal = () => {
    this.setState({ approvalModalIsOpen: true });
  };

  closeApprovalRequestModal = () => {
    this.setState({ approvalModalIsOpen: false, selectedReservations: [] });
  };

  openSingleApprovalModal = (reservation) => {
    this.setState({ singleApprovalReservation: reservation, singleApprovalModalIsOpen: true });
  };

  closeSingleApprovalModal = () => {
    this.setState({ singleApprovalReservation: null, singleApprovalModalIsOpen: false });
  };

  openAvailabilityInquiryModal = () => {
    this.setState({ availabilityModalIsOpen: true });
  };

  closeAvailabilityInquiryModal = () => {
    this.setState({ availabilityModalIsOpen: false, selectedReservations: [] });
  };

  openSingleAvailabilityModal = (reservation) => {
    this.setState({ singleAvailabilityReservation: reservation, singleAvailabilityModalIsOpen: true });
  };

  closeSingleAvailabilityModal = () => {
    this.setState({ singleAvailabilityReservation: null, singleAvailabilityModalIsOpen: false });
  };

  openCustomerApprovalRequestModal = () => {
    this.setState({ customerApprovalModalIsOpen: true });
  };

  closeCustomerApprovalRequestModal = () => {
    this.setState({ customerApprovalModalIsOpen: false, selectedReservations: [] });
  };

  openSingleCustomerApprovalModal = (reservation) => {
    this.setState({ singleCustomerApprovalReservation: reservation, singleCustomerApprovalModalIsOpen: true });
  };

  closeSingleCustomerApprovalModal = () => {
    this.setState({ singleCustomerApprovalReservation: null, singleCustomerApprovalModalIsOpen: false });
  };

  getEffectiveChainId = () => {
    var { workshop, selectedWorkshopChainId } = this.props;
    if (selectedWorkshopChainId) return selectedWorkshopChainId;
    return workshop && workshop.workshop_chain_id;
  };

  openApprovalDetailModal = (messageId) => {
    var _this = this;
    var workshop = this.props.workshop;
    var chainId = this.getEffectiveChainId();
    if (!chainId) return;
    axios.get(API_URL + '/uiapi/1/cs_message/' + messageId + '/?workshop_id=' + workshop.id + '&chain_id=' + chainId)
      .then(function (response) {
        _this.setState({ detailMessage: response.data, detailModalIsOpen: true });
      });
  };

  closeApprovalDetailModal = () => {
    this.setState({ detailMessage: null, detailModalIsOpen: false });
  };

  getApprovalBadge = (reservation) => {
    var _this = this;
    var t = (key) => this.props.t(key, { ns: 'ChainHomeView' });
    var colors = { pending: '#e67e22', approved: '#27ae60', rejected: '#e74c3c' };
    // Worded from the workshop's side: where the request went and what came back.
    // The internal message id said nothing to the reader; the send date does.
    var chainLabels = {
      pending: t('approvalSentToChain'),
      approved: t('approvalChainApproved'),
      rejected: t('approvalChainRejected'),
    };
    var customerLabels = {
      pending: t('approvalSentToCustomer'),
      approved: t('approvalCustomerApproved'),
      rejected: t('approvalCustomerRejected'),
    };
    var chainRequests = reservation.approval_requests || [];
    var customerRequests = reservation.customer_approval_requests || [];
    if (!chainRequests.length && !customerRequests.length) {
      return '-';
    }
    var renderRow = function (ar, labels, keyPrefix) {
      var sentAt = ar.created_at ? moment(ar.created_at).format('D.M.') : '';
      return (
        <span
          key={keyPrefix + ar.id}
          className='opacity-on-hover'
          title={ar.subject || ''}
          style={{ color: colors[ar.approval_status] || '#fff', fontWeight: 'bold', fontSize: 12, cursor: 'pointer' }}
          onClick={function (e) { e.stopPropagation(); _this.openApprovalDetailModal(ar.id); }}
        >
          {labels[ar.approval_status] || ar.approval_status}{sentAt ? ' ' + sentAt : ''}
        </span>
      );
    };
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {chainRequests.map(function (ar) { return renderRow(ar, chainLabels, 'chain-'); })}
        {customerRequests.map(function (ar) { return renderRow(ar, customerLabels, 'customer-'); })}
      </div>
    );
  };

  getSelectedReservationData = () => {
    const { csMaintenanceReservations } = this.props;
    const { selectedReservations } = this.state;
    if (!csMaintenanceReservations) return [];
    return csMaintenanceReservations.filter((r) => selectedReservations.includes(r.id));
  };

  setSelectedFields = (newSelectedFields) => {
    this.setState({ selectedFields: newSelectedFields });
    localStorage.setItem(SELECTED_FIELDS_KEY, JSON.stringify(newSelectedFields));
  };

  getChainFilterOptions = () => {
    var { workshop } = this.props;
    var t = (key) => this.props.t(key, { ns: 'ChainHomeView' });
    var options = [{ value: '', label: t('filterAllChains') }];
    if (workshop && workshop.workshop_chains && workshop.workshop_chains.length > 1) {
      workshop.workshop_chains.forEach(function (chain) {
        options.push({ value: String(chain.id), label: chain.name });
      });
    }
    return options;
  };

  getOrganizationOptions = () => {
    const { careServices } = this.props;
    const t = (key) => this.props.t(key, { ns: 'ChainHomeView' });
    const options = [
      { value: '', label: t('filterAllOrganizations') },
    ];
    const seen = {};

    if (careServices && careServices.length > 0) {
      careServices.forEach((cs) => {
        const org = cs.organization;
        if (org && org.id && !seen[org.id]) {
          seen[org.id] = true;
          options.push({
            value: String(org.id),
            label: org.name || '-',
          });
        }
      });
    }

    return options;
  }

  render() {
    const { csMaintenanceReservations, csMaintenanceReservationsStatus, workshop } = this.props;
    const { search, filters, selectedReservations, fields, selectedFields } = this.state;
    const t = (key) => this.props.t(key, { ns: 'ChainHomeView' });

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'topBarsContainer')}>
              <div style={getStyle(screenSize, styles, 'filterContainer')}>
                <div style={getStyle(screenSize, styles, 'filterRow')}>
                  <CBSearchInput
                    containerStyle={getStyle(screenSize, styles, 'searchInput')}
                    changeSearchTerms={this.changeSearchTerms}
                    onBlur={() => this.refetchReservations()}
                    value={search}
                  />

                  <div className='datepicker-dark' style={getStyle(screenSize, styles, 'datepickerWrapper')}>
                    <span style={styles.default.datepickerLabel}>{t('filterStartFrom')}</span>
                    <CBDatePickerInput
                      displayedDate={filters.start__gte ? moment(filters.start__gte) : moment()}
                      type='date'
                      dateFormat={finnishDateFormat}
                      changeDate={(value) => {
                        const newFilters = { ...filters };
                        if (value) {
                          newFilters.start__gte = moment(value).format('YYYY-MM-DD');
                        } else {
                          delete newFilters.start__gte;
                        }
                        this.setState({ filters: newFilters }, () => {
                          this.saveListStateToStorage();
                          this.refetchReservations();
                        });
                      }}
                    />
                  </div>

                  <div className='datepicker-dark' style={getStyle(screenSize, styles, 'datepickerWrapper')}>
                    <span style={styles.default.datepickerLabel}>{t('filterStartTo')}</span>
                    <CBDatePickerInput
                      displayedDate={filters.start__lte ? moment(filters.start__lte) : null}
                      type='date'
                      dateFormat={finnishDateFormat}
                      changeDate={(value) => {
                        const newFilters = { ...filters };
                        if (value) {
                          newFilters.start__lte = moment(value).format('YYYY-MM-DD');
                        } else {
                          delete newFilters.start__lte;
                        }
                        this.setState({ filters: newFilters }, () => {
                          this.saveListStateToStorage();
                          this.refetchReservations();
                        });
                      }}
                    />
                  </div>

                  <CBSelectFilters
                    name='organization_id'
                    options={this.getOrganizationOptions()}
                    onChange={(changedFilters) => {
                      const newFilters = { ...filters };
                      if (changedFilters.organization_id) {
                        newFilters.organization_id = changedFilters.organization_id;
                      } else {
                        delete newFilters.organization_id;
                      }
                      this.setState({ filters: newFilters }, () => {
                        this.saveListStateToStorage();
                        this.refetchReservations();
                      });
                    }}
                    value={filters.organization_id || ''}
                    selectStyle={getStyle(screenSize, styles, 'selectFilter')}
                  />

                  {workshop && workshop.workshop_chains && workshop.workshop_chains.length > 1 && (
                    <CBSelectFilters
                      name='chain_id'
                      options={this.getChainFilterOptions()}
                      onChange={(changedFilters) => {
                        var chainId = changedFilters.chain_id ? parseInt(changedFilters.chain_id) : null;
                        this.props.selectWorkshopChain(chainId);
                      }}
                      value={this.props.selectedWorkshopChainId ? String(this.props.selectedWorkshopChainId) : ''}
                      selectStyle={getStyle(screenSize, styles, 'selectFilter')}
                    />
                  )}
                </div>

                <div style={getStyle(screenSize, styles, 'actionBar')}>
                  <div style={getStyle(screenSize, styles, 'countTextContainer')}>
                    <p style={getStyle(screenSize, styles, 'selectedCountText')}>
                      {selectedReservations.length + ' valittu'}
                    </p>
                  </div>
                  <div style={{ marginLeft: 16 }}>
                    <CBButtonGarageAction
                      onClick={this.openApprovalRequestModal}
                      mainIcon='/img/icon_message_solid.svg'
                      text={t('approvalRequestButton')}
                      disabled={selectedReservations.length < 1}
                      additionalStylesMainIcon={{ height: 25, width: 25 }}
                    />
                  </div>
                  <div style={{ marginLeft: 8 }}>
                    <CBButtonGarageAction
                      onClick={this.openAvailabilityInquiryModal}
                      mainIcon='/img/icon_message_solid.svg'
                      text={t('availabilityInquiryButton')}
                      disabled={selectedReservations.length < 1}
                      additionalStylesMainIcon={{ height: 25, width: 25 }}
                    />
                  </div>
                  <div style={{ marginLeft: 8 }}>
                    <CBButtonGarageAction
                      onClick={this.openCustomerApprovalRequestModal}
                      mainIcon='/img/icon_message_solid.svg'
                      text={t('headingNewCustomerApproval')}
                      disabled={selectedReservations.length < 1}
                      additionalStylesMainIcon={{ height: 25, width: 25 }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              ref={this.topScrollRef}
              onScroll={this.handleTopScroll}
              style={getStyle(screenSize, styles, 'topScrollbar')}
              className="vehicle-table-scrollbar"
            >
              <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
            </div>
            <div
              ref={this.tableScrollRef}
              onScroll={this.handleTableScroll}
              style={getStyle(screenSize, styles, 'tableContainer')}
              className="vehicle-table-scrollbar"
            >
              {csMaintenanceReservationsStatus && csMaintenanceReservationsStatus.loading ? (
                <div style={getStyle(screenSize, styles, 'loadingContainer')}>
                  <p style={getStyle(screenSize, styles, 'loadingText')}>Ladataan...</p>
                </div>
              ) : (
                <table style={getStyle(screenSize, styles, 'table')}>
                  <thead>
                    <tr>
                      <th style={styleMerge(
                        getStyle(screenSize, styles, 'tableHeaderFirst'),
                        getStyle(screenSize, styles, 'alignCenter')
                      )}>
                        <CBLabelAndCheckbox
                          checked={csMaintenanceReservations && selectedReservations.length === csMaintenanceReservations.length && csMaintenanceReservations.length > 0}
                          additionalStyles={{ justifyContent: 'center' }}
                          onChange={this.selectAllChanged}
                        />
                      </th>

                      {selectedFields.includes('reg_nr') && (
                        <VehicleListTh
                          text={t('headingRegNr')}
                          fieldName='reg_nr'
                          orderingSymbol={this.getOrderingSymbol('reg_nr')}
                          changeOrdering={() => {
                            this.changeOrdering('reg_nr');
                          }}
                        />
                      )}

                      {selectedFields.includes('organization_name') && (
                        <VehicleListTh
                          text={t('headingOrganization')}
                          fieldName='organization'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('start') && (
                        <VehicleListTh
                          text={t('headingStartTime')}
                          fieldName='start'
                          orderingSymbol={this.getOrderingSymbol('start')}
                          changeOrdering={() => {
                            this.changeOrdering('start');
                          }}
                        />
                      )}

                      {selectedFields.includes('end') && (
                        <VehicleListTh
                          text={t('headingEndTime')}
                          fieldName='end'
                          orderingSymbol={this.getOrderingSymbol('end')}
                          changeOrdering={() => {
                            this.changeOrdering('end');
                          }}
                        />
                      )}

                      {selectedFields.includes('description') && (
                        <VehicleListTh
                          text={t('headingDescription')}
                          fieldName='description'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('autofutur_created') && (
                        <VehicleListTh
                          text={t('headingCreatedAt')}
                          fieldName='autofutur_created'
                          orderingSymbol={this.getOrderingSymbol('autofutur_created')}
                          changeOrdering={() => {
                            this.changeOrdering('autofutur_created');
                          }}
                        />
                      )}

                      {selectedFields.includes('user_id') && (
                        <VehicleListTh
                          text={t('headingBooker')}
                          fieldName='user_id'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('part_items_ordered') && (
                        <VehicleListTh
                          text={t('headingPartsOrdered')}
                          fieldName='part_items_ordered'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('latest_km') && (
                        <VehicleListTh
                          text={t('headingLatestKm')}
                          fieldName='latest_km'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('last_maintenance') && (
                        <VehicleListTh
                          text={t('headingLastMaintenance')}
                          fieldName='last_maintenance'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('approval_status') && (
                        <VehicleListTh
                          text={t('headingApprovalStatus')}
                          fieldName='approval_status'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('new_approval_request') && (
                        <VehicleListTh
                          text={t('headingNewApprovalRequest')}
                          fieldName='new_approval_request'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('new_availability_inquiry') && (
                        <VehicleListTh
                          text={t('headingNewAvailabilityInquiry')}
                          fieldName='new_availability_inquiry'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('new_customer_approval') && (
                        <VehicleListTh
                          text={t('headingNewCustomerApproval')}
                          fieldName='new_customer_approval'
                          notSortable
                        />
                      )}

                      <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                        <MultiSelect
                          value={selectedFields}
                          onChange={(e) => this.setSelectedFields(e.value)}
                          options={fields}
                          className="bars"
                          dropdownIcon={undefined}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {csMaintenanceReservations && csMaintenanceReservations.length > 0 ? (
                      csMaintenanceReservations.map((reservation) => (
                        <tr
                          key={reservation.id}
                          style={getStyle(screenSize, styles, 'tableRow')}
                          onClick={() => {
                            if (reservation.vehicle) {
                              this.props.history.push(`/vehicle/${reservation.vehicle}/reservations/${reservation.id}`);
                            }
                          }}
                        >
                          <td
                            style={getStyle(screenSize, styles, 'tableCheckboxTd')}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <CBLabelAndCheckbox
                              additionalStyles={{ justifyContent: 'center' }}
                              checked={selectedReservations.includes(reservation.id)}
                              onChange={() => {
                                if (selectedReservations.includes(reservation.id)) {
                                  this.unselectReservation(reservation.id);
                                } else {
                                  this.selectReservation(reservation.id);
                                }
                              }}
                            />
                          </td>

                          {selectedFields.includes('reg_nr') && (
                            <VehicleListTd
                              textPrimary={reservation.reg_nr}
                              textSecondary={[reservation.manufacturer, reservation.model_name].filter(Boolean).join(' ')}
                              additionalStylesPrimaryText={{ fontSize: 24 }}
                            />
                          )}

                          {selectedFields.includes('organization_name') && (
                            <VehicleListTd
                              textPrimary={reservation.organization_name || '-'}
                            />
                          )}

                          {selectedFields.includes('start') && (
                            <VehicleListTd
                              textPrimary={reservation.start ? moment(reservation.start).format('DD.MM.YYYY HH:mm') : '-'}
                            />
                          )}

                          {selectedFields.includes('end') && (
                            <VehicleListTd
                              textPrimary={reservation.end ? moment(reservation.end).format('DD.MM.YYYY HH:mm') : '-'}
                            />
                          )}

                          {selectedFields.includes('description') && (
                            <VehicleListTd
                              textPrimary={reservation.description || '-'}
                            />
                          )}

                          {selectedFields.includes('autofutur_created') && (
                            <VehicleListTd
                              textPrimary={reservation.autofutur_created ? moment(reservation.autofutur_created).format('DD.MM.YYYY') : '-'}
                            />
                          )}

                          {selectedFields.includes('user_id') && (
                            <VehicleListTd
                              textPrimary={reservation.user_name || reservation.user_id || '-'}
                            />
                          )}

                          {selectedFields.includes('part_items_ordered') && (
                            <VehicleListTd
                              textPrimary={reservation.part_items_ordered ? this.props.t('yes', { ns: 'common' }) : this.props.t('no', { ns: 'common' })}
                            />
                          )}

                          {selectedFields.includes('latest_km') && (
                            <VehicleListTd
                              textPrimary={reservation.latest_km ? Number(reservation.latest_km).toLocaleString('fi-FI') + ' km' : '-'}
                              textSecondary={reservation.latest_km_date ? moment(reservation.latest_km_date).format('DD.MM.YYYY') : ''}
                            />
                          )}

                          {selectedFields.includes('last_maintenance') && (
                            <VehicleListTd
                              textPrimary={reservation.last_maintenance_date ? moment(reservation.last_maintenance_date).format('DD.MM.YYYY') : '-'}
                              textSecondary={reservation.last_maintenance_km ? Number(reservation.last_maintenance_km).toLocaleString('fi-FI') + ' km' : ''}
                            />
                          )}

                          {selectedFields.includes('approval_status') && (
                            <VehicleListTd
                              textPrimary={this.getApprovalBadge(reservation)}
                            />
                          )}

                          {selectedFields.includes('new_approval_request') && (
                            <td
                              style={getStyle(screenSize, styles, 'alignCenter')}
                              onClick={(e) => { e.stopPropagation(); this.openSingleApprovalModal(reservation); }}
                            >
                              <img
                                alt='New approval request'
                                className='opacity-and-border-on-hover'
                                src='/img/icon_new_message.svg'
                                style={{ cursor: 'pointer' }}
                              />
                            </td>
                          )}

                          {selectedFields.includes('new_availability_inquiry') && (
                            <td
                              style={getStyle(screenSize, styles, 'alignCenter')}
                              onClick={(e) => { e.stopPropagation(); this.openSingleAvailabilityModal(reservation); }}
                            >
                              <img
                                alt='New availability inquiry'
                                className='opacity-and-border-on-hover'
                                src='/img/icon_new_message.svg'
                                style={{ cursor: 'pointer', opacity: 0.7 }}
                              />
                            </td>
                          )}

                          {selectedFields.includes('new_customer_approval') && (
                            <td
                              style={getStyle(screenSize, styles, 'alignCenter')}
                              title={t('newCustomerApprovalTooltip')}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!reservation.organization_id) { return; }
                                this.openSingleCustomerApprovalModal(reservation);
                              }}
                            >
                              <img
                                alt='New customer approval request'
                                className='opacity-and-border-on-hover'
                                src='/img/icon_new_message.svg'
                                style={{ cursor: reservation.organization_id ? 'pointer' : 'not-allowed', opacity: reservation.organization_id ? 1 : 0.3 }}
                              />
                            </td>
                          )}

                          <td style={getStyle(screenSize, styles, 'tableOptionsTd')} />
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={selectedFields.length + 2} style={getStyle(screenSize, styles, 'noDataCell')}>
                          {t('noReservationsFound')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {this.state.approvalModalIsOpen && (
              <CreateChainMessageModal
                modalIsOpen={this.state.approvalModalIsOpen}
                closeModal={this.closeApprovalRequestModal}
                chainId={this.getEffectiveChainId()}
                presetMessageType='approval_request'
                presetReservations={this.getSelectedReservationData()}
              />
            )}

            {this.state.singleApprovalModalIsOpen && this.state.singleApprovalReservation && (
              <CreateChainMessageModal
                modalIsOpen={this.state.singleApprovalModalIsOpen}
                closeModal={this.closeSingleApprovalModal}
                chainId={this.state.singleApprovalReservation.workshop_chain || this.getEffectiveChainId()}
                presetMessageType='approval_request'
                presetReservations={[this.state.singleApprovalReservation]}
              />
            )}

            {this.state.availabilityModalIsOpen && (
              <CreateChainMessageModal
                modalIsOpen={this.state.availabilityModalIsOpen}
                closeModal={this.closeAvailabilityInquiryModal}
                chainId={this.getEffectiveChainId()}
                presetMessageType='availability_inquiry'
                presetReservations={this.getSelectedReservationData()}
              />
            )}

            {this.state.singleAvailabilityModalIsOpen && this.state.singleAvailabilityReservation && (
              <CreateChainMessageModal
                modalIsOpen={this.state.singleAvailabilityModalIsOpen}
                closeModal={this.closeSingleAvailabilityModal}
                chainId={this.state.singleAvailabilityReservation.workshop_chain || this.getEffectiveChainId()}
                presetMessageType='availability_inquiry'
                presetReservations={[this.state.singleAvailabilityReservation]}
              />
            )}

            {this.state.customerApprovalModalIsOpen && (
              <CreateChainMessageModal
                modalIsOpen={this.state.customerApprovalModalIsOpen}
                closeModal={this.closeCustomerApprovalRequestModal}
                chainId={this.getEffectiveChainId()}
                presetMessageType='customer_approval'
                presetReservations={this.getSelectedReservationData()}
              />
            )}

            {this.state.singleCustomerApprovalModalIsOpen && this.state.singleCustomerApprovalReservation && (
              <CreateChainMessageModal
                modalIsOpen={this.state.singleCustomerApprovalModalIsOpen}
                closeModal={this.closeSingleCustomerApprovalModal}
                chainId={this.state.singleCustomerApprovalReservation.workshop_chain || this.getEffectiveChainId()}
                presetMessageType='customer_approval'
                presetReservations={[this.state.singleCustomerApprovalReservation]}
              />
            )}

            {this.state.detailModalIsOpen && this.state.detailMessage && (
              <ChainMessageDetailModal
                message={this.state.detailMessage}
                modalIsOpen={this.state.detailModalIsOpen}
                closeModal={this.closeApprovalDetailModal}
              />
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    topBarsContainer: {
      paddingLeft: 16,
      paddingTop: 16,
      marginBottom: 16,
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    filterRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: 12,
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    searchInput: {
      height: 40,
      width: 200,
      marginLeft: 0,
    },
    datepickerWrapper: {
      width: 200,
      flexShrink: 0,
    },
    datepickerLabel: {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: 13,
      marginRight: 6,
      whiteSpace: 'nowrap',
    },
    selectFilter: {
      width: 200,
      marginLeft: 0,
      marginRight: 0,
    },
    actionBar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 8,
    },
    countTextContainer: {
      minWidth: 60,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    selectedCountText: {
      fontFamily: 'TitilliumWeb-Bold',
      color: '#FFFFFF',
      marginBottom: 0,
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '24px',
      paddingBottom: 16,
      position: 'relative',
    },
    table: {
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    topScrollbar: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      marginTop: 12,
    },
    topScrollbarInner: {
      height: 1,
    },
    tableRow: {
      height: '60px',
      width: '100%',
      cursor: 'pointer',
    },
    tableHeaderFirst: {
      left: 0,
      padding: '8px 16px',
    },
    tableHeaderSettings: {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
      right: 0,
    },
    alignCenter: {
      textAlign: 'center',
    },
    tableCheckboxTd: {
      fontFamily: 'TitilliumWeb-Bold',
      fontSize: 18,
      color: '#FFFFFF',
      left: 0,
      padding: '8px 16px 8px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    tableOptionsTd: {
      right: 0,
      padding: '0 16px 0 16px',
      zIndex: 0,
    },
    noDataCell: {
      padding: '24px 16px',
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 14,
      textAlign: 'center',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
    },
    loadingText: {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 14,
    },
  },
  medium: {
    searchInput: {
      height: 40,
      width: 180,
      marginLeft: 0,
    },
    datepickerWrapper: {
      width: 190,
      flexShrink: 0,
    },
    selectFilter: {
      width: 180,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  small: {
    filterRow: {
      gap: 8,
    },
    searchInput: {
      height: 40,
      width: '100%',
      marginLeft: 0,
      marginTop: 12,
    },
    datepickerWrapper: {
      width: 'calc(50% - 4px)',
      flexShrink: 0,
    },
    selectFilter: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
    },
  },
};

function mapStateToProps(state) {
  return {
    csMaintenanceReservations: state.chain.csMaintenanceReservations,
    csMaintenanceReservationsStatus: state.chain.csMaintenanceReservationsStatus,
    careServices: state.careService.careServices,
    selectedWorkshopChainId: state.workshop.selectedWorkshopChainId,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchCSMaintenanceReservations: _fetchCSMaintenanceReservations,
    fetchCareServices: _fetchCareServices,
    selectWorkshopChain: _selectWorkshopChain,
  },
)(withRouter(translate('ChainHomeView')(CSUpcomingMaintenancesView)));
